import styled from "styled-components";

import { ReactComponent as BellSVG } from "../assets/svg/bell-icon.svg";
import { ReactComponent as GearIconSVG } from "../assets/svg/gear-icon.svg";

import { ReactComponent as TransferSVG } from "../assets/svg/transfer-icon.svg";
import { ReactComponent as BillSVG } from "../assets/svg/bill-icon.svg";
import { ReactComponent as CreditCardSVG } from "../assets/svg/credit-card-icon.svg";
import { ReactComponent as NewAccountSVG } from "../assets/svg/new-account-icon.svg";

export const AccountContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 120vh;
  background-color: ${(props) => props.theme.firstColor};

  @media (max-width: 1536px) {
    height: 180vh;
  }

  > div {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: calc(100% - 7vh); // header height
    max-width: 1200px;
    padding-bottom: 4vh;
    background: transparent;

    @media (max-width: 1536px) {
      height: calc(100% - 9vh);
    }
    @media (max-width: 1366px) {
      max-width: 1024px;
    }
    @media (max-width: 1124px) {
      max-width: none;
      padding-right: 50px;
      padding-left: 50px;
    }
`;
export const AccountHeader = styled.header`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 7vh;
  padding: 2vh 0 1vh 0;
  background-color: ${(props) => props.theme.tenthColor};

  @media (max-width: 1536px) {
    height: 9vh;
  }

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 1200px;

    @media (max-width: 1366px) {
      max-width: 1024px;
    }
    @media (max-width: 1124px) {
      max-width: none;
      padding: 0 50px;
    }
  }
`;
export const AccountHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  flex: 1;

  span:nth-of-type(1) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90%;
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    background-color: ${(props) => props.theme.secondColor};
    margin-right: 1rem;

    p {
      margin: 0;
      font-size: 1.8rem;
      font-weight: bold;
      color: ${(props) => props.theme.tenthColor};
    }
  }
  span:nth-of-type(2) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    width: auto;

    p {
      margin: 0;
    }
    p:nth-of-type(1) {
      font-weight: bold;
      font-size: 1.2rem;
      color: black;
    }
    p:nth-of-type(2) {
      font-size: 0.7rem;
      color: ${(props) => props.theme.secondColor};
    }
  }
`;
export const AccountHeaderRight = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  span {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    p {
      margin: 0;
    }
    p:nth-of-type(1) {
      font-size: 0.8rem;
      color: ${(props) => props.theme.secondColor};
    }
    p:nth-of-type(2) {
      color: black;
      font-size: 0.9rem;
    }
  }

  div {
    display: flex;
    align-items: center;
    margin-left: 1.5rem;
  }
`;

export const AccountFirstRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: clamp(200px, 32%, 300px);
  margin-bottom: 0.5rem;

  p {
    color: ${(props) => props.theme.tenthColor};
    font-weight: bold;
    margin: 0;
  }
  > p:nth-of-type(1) {
    margin: 10px 0 0 0;
  }

  > div:nth-of-type(2) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 20%;
    background-color: ${(props) => props.theme.secondColor};
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    border-radius: 47px;
    padding: 0 1rem;

    p {
      margin: 0;
    }

    button {
      height: 60%;
      padding: 0 1.5rem;
      border: none;
      border-radius: 47px;
      font-weight: bold;
      color: ${(props) => props.theme.firstColor};
      background-color: ${(props) => props.theme.tenthColor};
    }
  }
`;
export const AccountFirstRowOptions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40%;
  width: 100%;
  margin-top: 10px;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 17%;
    border-radius: 7px;
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.5);
    background-color: ${(props) => props.theme.tenthColor};

    @media (max-width: 1000px) {
      width: 18%;
    }

    p {
      margin: 0;
      color: black;

      @media (max-width: 1000px) {
        font-size: 0.7rem;
      }
    }
  }
`;

export const AccountSecondRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  height: 40%;
  width: 100%;
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: ${(props) => props.theme.tenthColor};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  border-radius: 7px;

  h2 {
    font-size: 1.2rem;
  }

  > div {
    width: 100%;
    flex: 1;

    > div {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 0.8rem 0.4rem;
      margin-bottom: 0.4rem;
      border-radius: 5px;
      background-color: ${(props) => props.theme.thirdColor};

      p {
        margin: 0;
        font-weight: bold;
        font-size: 0.8rem;
        color: ${(props) => props.theme.secondColor};
      }
    }
  }
`;
export const AccountTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 0.5rem;

  && thead {
    width: 100%;

    th {
      border-bottom: 1px solid black;
      padding-bottom: 5px;
    }

    th:nth-of-type(1) {
      text-align: left;
      font-size: 0.8rem;
      color: ${(props) => props.theme.secondColor};
    }
    th:nth-of-type(2) {
      text-align: right;
      font-size: 0.8rem;
      color: ${(props) => props.theme.secondColor};
    }
  }

  && tbody {
    width: 100%;

    td:nth-of-type(1) {
      padding: 0.2rem 0;
      text-align: left;
      font-size: 0.8rem;
      color: black;
    }
    td:nth-of-type(2) {
      padding: 0.2rem 0;
      text-align: right;
      font-size: 0.8rem;
      color: black;
      font-weight: bold;
    }
  }
`;

export const AccountThirdRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 25%;
  width: 100%;
  padding: 1rem;
  border-radius: 7px;
  flex-grow: 0.9;
  background-color: ${(props) => props.theme.tenthColor};

  h2 {
    font-size: 1.2rem;
    margin: 0;
  }

  div {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    padding-top: 1.4rem;

    p {
      font-size: 0.8rem;
      margin: 0;
      color: #969696;
    }
  }
`;

//Icons
export const BellIcon = styled(BellSVG)`
  width: 1.5rem;
  height: 1.5rem;
`;
export const GearIcon = styled(GearIconSVG)`
  width: 1.5rem;
  height: 1.5rem;
  margin-left: 1rem;
`;

export const TransferIcon = styled(TransferSVG)`
  width: 3.5rem;
  height: 3.5rem;
  margin-bottom: 0.4rem;
`;
export const BillIcon = styled(BillSVG)`
  width: 3.5rem;
  height: 3.5rem;
  margin-bottom: 0.4rem;
`;
export const CreditCardIcon = styled(CreditCardSVG)`
  width: 3.5rem;
  height: 3.5rem;
  margin-bottom: 0.4rem;
`;
export const NewAccountIcon = styled(NewAccountSVG)`
  width: 3.5rem;
  height: 3.5rem;
  margin-bottom: 0.4rem;
`;
